import { render, staticRenderFns } from "./tinyPhoto.vue?vue&type=template&id=d48c6b9c&scoped=true&"
import script from "./tinyPhoto.vue?vue&type=script&lang=js&"
export * from "./tinyPhoto.vue?vue&type=script&lang=js&"
import style0 from "./tinyPhoto.vue?vue&type=style&index=0&id=d48c6b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48c6b9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/liuminming/Documents/zhunduWork/components/photoScanView/photo-scan-view/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d48c6b9c')) {
      api.createRecord('d48c6b9c', component.options)
    } else {
      api.reload('d48c6b9c', component.options)
    }
    module.hot.accept("./tinyPhoto.vue?vue&type=template&id=d48c6b9c&scoped=true&", function () {
      api.rerender('d48c6b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tinyPhoto.vue"
export default component.exports